import { render, staticRenderFns } from "./orderLog.vue?vue&type=template&id=39387109&scoped=true&"
import script from "./orderLog.vue?vue&type=script&lang=js&"
export * from "./orderLog.vue?vue&type=script&lang=js&"
import style0 from "./orderLog.vue?vue&type=style&index=0&id=39387109&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39387109",
  null
  
)

export default component.exports